export const reading_no= {
    title:"Dagens personlige avlesning",
    readings:[
        {
            id:1,
            text:"De intuitive følelsene mine forteller meg at du gjennomgår noen utfordrende livsbeslutninger akkurat nå, og at du er usikker på hvordan du skal gripe dem fatt, noe som forårsaker vanskelighetene dine.",
        },
        {
            id:2,
            text:"For tiden balanserer du to eller flere ting i livet ditt. Du har mange jern i ilden. Kortene viste at du drar nytte av alt du har oppnådd og lært i livet ditt fram til nå, og at du kan bruke dette som et springbrett og en katalysator du kan navigere fra. Alt du opplever nå kan du gjøre om til en vakker ny visjon og tydelighet i livet ditt.",
        },
        {
            id:3,
            text:"Veiledning: Kortene viser at du balanserer tingene i livet ditt på en god måte til tross for hvordan du oppfatter dem.",
        },
        {
            id:4,
            text:"Kortene viste også at det finnes et potensial for en sterk energi som kan gjøre at ting utvikler seg raskt, noe som betyr at du må ta en beslutning eller nå en form for en konklusjon. Dette kortet kan representere deg eller en mannlig figur i livet ditt. Denne personen er sannsynligvis middelaldrende, modig og har en tendens til å handle raskt og ta raske beslutninger som ikke alltid er nøye planlagt.",
        },
        {
            id:5,
            text:"Andre mennesker og universet betrakter deg som veldig talentfull og at du kan skape deg et meningsfullt liv. Andre betrakter deg som en person som lykkes med planene sine, siden du bruker så mye tanker, fokus, energi og innsats på å realisere dem. Du får ting gjort ved å bruke dine egne talenter og ferdigheter. Det er nemlig ikke alle som har disse evnene, initiativet og viljen til å få ting gjort.",
        },
            
    ]
}



// WEBPACK FOOTER //
// ./src/utils/reading_no.js